<template>
  <v-row
      class="c-medication-row border-bottom"
      :class="[selected ? 'bg-color-coro-lightgray' : '', schedule.wasDeletedByTypesSinceLastSDM ? 'strike-through' : '']"
  >
    <v-col cols="8" class="border-right" @click="(event) => $emit('click:informationicon', { event, schedule })">
      <v-row class="px-2">
        <v-col cols="1">
          <smart-icon
              :icon="
              schedule.medication.form.coding[0].code === '46992007'
                ? 'mdi-pill'
                : 'mdi-needle'
            "
              size="20"
          />
        </v-col>
        <v-col cols="9">
          <span class="c-medication-row__medication deleted" v-if="schedule.wasDeletedByTypesSinceLastSDM">
            {{ schedule.medication.name }}
          </span>
          <span class="c-medication-row__medication" v-else-if="schedule.wasCreatedByTypesSinceLastSDM && !schedule.wasDeletedByTypesSinceLastSDM" >
            {{ schedule.medication.name }} (<smart-icon icon="mdi-plus"/>)
          </span>
          <span class="c-medication-row__medication" v-else-if="schedule.wasUpdatedByTypesSinceLastSDM && !schedule.wasDeletedByTypesSinceLastSDM" >
            {{ schedule.medication.name }} (<smart-icon icon="mdi-pencil-outline"/>)
          </span>
          <span class="c-medication-row__medication" v-else >
            {{ schedule.medication.name }}
          </span>
        </v-col>
        <v-col cols="2" align-self="end">
          <span
              class="c-medication-row__medication-dose"
              v-for="(doseAndRate, index) in schedule.dosage.doseAndRate"
              v-bind:key="doseAndRate.id"
          >
            <span v-if="index > 0"> / </span>
            {{ doseAndRate.doseQuantity.value }}
            {{ doseAndRate.doseQuantity.code === 'unknown' ?
              $t(`dss.allergies.unknown`) :
              $t(`units.${updateDoseCodeTranslationIfNeeded(doseAndRate.doseQuantity.code)}`, {catalog: 'app_mobile'})
            }}
          </span>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <!-- <v-spacer /> -->
        <v-col cols="12">
          <span class="c-medication-row__medication-frequency">
            {{ this.$app.scheduleManager.scheduleToString(schedule.schedule) }}
          </span>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <v-col>
          <v-row>
            <v-col
                cols="3"
                class="c-medication-row__medication-time morning"
                :class="
                numberOfMedicationsPerQuartile[0].amount > 0
                  ? 'has_medication'
                  : ''
              "
            >
              <p>
                {{ $t("general.morning", {catalog: 'app_mobile'}) }}
              </p>
            </v-col>
            <v-col
                cols="3"
                class="c-medication-row__medication-time noon"
                :class="
                numberOfMedicationsPerQuartile[1].amount > 0
                  ? 'has_medication'
                  : ''
              "
            >
              <p>
                {{ $t("general.noon", {catalog: 'app_mobile'}) }}
              </p>
            </v-col>
            <v-col
                cols="3"
                class="c-medication-row__medication-time afternoon"
                :class="
                numberOfMedicationsPerQuartile[2].amount > 0
                  ? 'has_medication'
                  : ''
              "
            >
              <p>
                {{ $t("general.afternoon", {catalog: 'app_mobile'}) }}
              </p>
            </v-col>
            <v-col
                cols="3"
                class="c-medication-row__medication-time evening"
                :class="
                numberOfMedicationsPerQuartile[3].amount > 0
                  ? 'has_medication'
                  : ''
              "
            >
              <p>
                {{ $t("general.evening", {catalog: 'app_mobile'}) }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="c-medication-row__medication-times">
              <span>
                {{
                  numberOfMedicationsPerQuartile[0].amount > 0
                      ? numberOfMedicationsPerQuartile[0].amount
                      : ""
                }}
              </span>
            </v-col>
            <v-col cols="3" class="c-medication-row__medication-times">
              <span>
                {{
                  numberOfMedicationsPerQuartile[1].amount > 0
                      ? numberOfMedicationsPerQuartile[1].amount
                      : ""
                }}
              </span>
            </v-col>
            <v-col cols="3" class="c-medication-row__medication-times">
              <span>
                {{
                  numberOfMedicationsPerQuartile[2].amount > 0
                      ? numberOfMedicationsPerQuartile[2].amount
                      : ""
                }}
              </span>
            </v-col>
            <v-col cols="3" class="c-medication-row__medication-times">
              <span>
                {{
                  numberOfMedicationsPerQuartile[3].amount > 0
                      ? numberOfMedicationsPerQuartile[3].amount
                      : ""
                }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="3" class="border-right">
      <v-row>
        <v-col>
          <v-select
              v-model="selectedClasses"
              :items="classesForSelect"
              :menu-props="{ maxHeight: '400' }"
              multiple
              hint="Select the medication class"
              :label="$t('pdf.medicationPrescription.table.classes', {catalog: 'messages'})"
              @input="onChangeSelect"
              :disabled="schedule.wasDeletedByTypesSinceLastSDM"
              dense
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="showReason">
        <v-col>
          <p
              class="c-medication-row__medication-motivation-of-change"
              v-for="desc in medicationClassesInformations"
              v-bind:key="desc.key"
          >
            {{ desc.desc }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col
        v-if="!selected"
        cols="1"
        class=""
        @click="(event) => $emit('click:informationicon', { event, schedule })"
    >
      <smart-icon icon="mdi-information-outline"/>
    </v-col>
    <v-col
        v-if="selected"
        cols="1"
        @click="(event) => $emit('click:informationicon', { event, schedule })"
    >
      <smart-icon icon="mdi-arrow-right" :iconColor="$color.coro['info-500']"/>
    </v-col>
    <duplicated-class-popup
      :value="showDialog"
      :duplicatedClasses="duplicatedClasses.join(', ')"
      @close="cancelClassUpdate"
      @handleSubmit="updateMedicationClasses(classesToSubmit)"
    />
  </v-row>
</template>

<script>
import SmartIcon from "./SmartIcon.vue";
import gql from "graphql-tag";
import {mapGetters} from 'vuex';
import {UCUMUnit} from '../../../../helper/UCUMUnit';
import DuplicatedClassPopup from '../../components/Parts/DSS/DuplicatedClassPopup.vue';
import {simpleClone} from "../../../../helper/objects";
import { debounce } from 'debounce'

/**
 * Component MedicationRow.vue
 *
 * @module MedicationRow
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/MedicationRow.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "MedicationRow",
  components: {
    SmartIcon,
    DuplicatedClassPopup
  },
  props: {
    schedule: {},
    selected: {
      default: () => false,
    },
    medicationClasses: {},
    showReason: {
      type: Boolean,
      default: () => true
    },
    allSelectedMedicationClasses: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    getSelectedMedicationClassKeys: function(){
      return this?.schedule.medication.classes.map(item => item.key) || [];
    }
  },
  watch: {
    selectedClasses: function () {
      let descriptions = [];

      this.selectedClasses.forEach((c) => {
        const found = this.medicationClasses.find((val) => {
          return val.name == c;
        });

        if (found) {
          descriptions.push({
            key: found.key,
            desc: found.description,
          });
        }
      });

      this.medicationClassesInformations = descriptions;
    },

    schedule() {
      this.savingInProgress = false;
    },

    savingInProgress(curr) {
      // disable selection while saving medication classes
      if (curr) {
        this.classesForSelect = this.classesForSelect.map(item => {
          item.disabled = true;
          return item
        })
      } else {
        this.classesForSelect = this.classesForSelect.map(item => {
          item.disabled = false;
          return item
        })
      }
    }
  },
  data: function () {
    return {
      numberOfMedicationsPerQuartile: [
        {
          amount: 0,
        },
        {
          amount: 0,
        },
        {
          amount: 0,
        },
        {
          amount: 0,
        },
      ],
      selectedClasses: [],
      scheduleId: null,
      classesForSelect: [],
      medicationClassesInformations: [],
      showDialog: false,
      classesToSubmit: [],
      classesToSubmitWithoutDuplicates: [],
      duplicatedClasses: [],
      initialSelection: [],
      savingInProgress: false
    };
  },
  mounted: function () {
    // Fill select options
    this.medicationClasses.forEach((medicationClass) => {
      this.classesForSelect.push({
        text: medicationClass.name,
        value: medicationClass.name
      });
    });

    // Amount per quartile
    if (this.schedule?.intakeMoments.length) {
      this.schedule.intakeMoments.forEach((intakeMoment) => {
        const quartile = this.getQuartile(intakeMoment.time);

        switch (quartile) {
          case "MORNING":
            this.numberOfMedicationsPerQuartile[0].amount +=
                intakeMoment.amount;
            break;
          case "NOON":
            this.numberOfMedicationsPerQuartile[1].amount +=
                intakeMoment.amount;
            break;
          case "AFTERNOON":
            this.numberOfMedicationsPerQuartile[2].amount +=
                intakeMoment.amount;
            break;
          case "EVENING":
            this.numberOfMedicationsPerQuartile[3].amount +=
                intakeMoment.amount;
            break;
        }
      });
    }

    // Fill in selected class(es)
    if (this.schedule?.medication.classes.length) {
      this.schedule.medication.classes.forEach((c) => {
        this.selectedClasses.push(c.name);
      });
    }

    this.initialSelection = this.selectedClasses;
  },
  methods: {
    updateDoseCodeTranslationIfNeeded(code) {
      return new UCUMUnit(code).updateDoseCodeTranslationIfNeeded();
    },
    getQuartile(time) {
      return this.$store.getters['patientSummary/quartiles'].get(time);
    },
    onChangeSelect(e) {
      // Check for duplicated classes
      this.checkForDuplicatedClasses(e);
    },
    checkForDuplicatedClasses(classes) {
      let allSelectedClasses = [...this.allSelectedMedicationClasses];
      let initialSelectionKeys = this.getSelectedMedicationClassKeys;
      let classesWithKeys = [];

      // get keys
      classes.forEach((c) => {
        const found = this.medicationClasses.find((val) => {
          return val.name === c;
        });
        if (found) {
          classesWithKeys.push(found.key);
        }
      });

      // don't count classes from this prescription
      initialSelectionKeys.forEach(item => {
        const index = allSelectedClasses.findIndex(c => c.key === item);
        if (index >= 0) {
          allSelectedClasses.splice(index, 1)
        }
      })

      const duplicates = [];
      const classesWithKeysWithoutDuplicates = classesWithKeys.filter((key) => {
        const duplicate = allSelectedClasses.find(c => c.key === key);
        // check if duplicate was already initially selected
        const initialDuplicate = initialSelectionKeys.includes(key)

        if (duplicate && !initialDuplicate) {
          duplicates.push(duplicate.name);
          return false
        }
        return true
      });

      if (duplicates.length) {
        this.showDialog = true;
        this.classesToSubmit = classesWithKeys;
        this.duplicatedClasses = duplicates;
        this.classesWithoutDuplicatesToSubmit = classesWithKeysWithoutDuplicates;
        // stop saving process
        this.updateMedicationClasses(classesWithKeys, true)
      } else {
        this.updateMedicationClasses(classesWithKeys)
      }
    },

    cancelClassUpdate() {
      // only cancel update for duplicates classes - allow rest to be saved
      this.showDialog = false;
      this.selectedClasses = this.selectedClasses.filter(item => !this.duplicatedClasses.includes(item))
      this.classesToSubmit = [];
      this.duplicatedClasses = [];
      this.updateMedicationClasses(this.classesWithoutDuplicatesToSubmit)
    },

    updateMedicationClasses: debounce(async function(classes, abort) {
      const initialSelectionKeys = this.getSelectedMedicationClassKeys;
      const sameAsInitialSelection = initialSelectionKeys.sort().join(',') === classes.sort().join(',')

      // abort in case of duplicated class
      // or if medication class selection hasn't changed -> can happen bacause of debounce
      if (abort || sameAsInitialSelection) {
        return;
      }

      const myMedicationScheduleId = this.schedule.id;
      this.showDialog = false;
      this.savingInProgress = true

      // Look for indexes that have to be removed from dosages
      const deletedIndexes = []

      if (classes.length > 0){
        this.getSelectedMedicationClassKeys.forEach((mClass, index) => {
          if (!classes.includes(mClass)){
            deletedIndexes.push(index)
          }
        })
      }

      // format dosages, filter out the ones that have been deleted
      const dosages = this.schedule.dosage.doseAndRate
          .filter((item, index) => !deletedIndexes.includes(index))
          .map(item => {
        return {
          value: item.doseQuantity.value,
          unit: item.doseQuantity.code,
          id: item.id
        }
      });

      // add new missing dosage if a new medication class was added
      const diff = classes.length - dosages.length;

      if (diff > 0) {
        const copies = new Array(diff).fill(simpleClone(dosages[dosages.length-1]));
        dosages.push(...copies);
        dosages[dosages.length-1].id = null;
      }

      this.$app.apolloMobileClient
        .mutate({
          mutation: gql`
            mutation createUpdateMyMedicationSchedule(
              $medicationSchedule: CreateUpdateMyMedicationSchedule
            ){
              createUpdateMyMedicationSchedule(
                medicationSchedule: $medicationSchedule
              ) {
                id
              }
            }`,
            variables: {
              medicationSchedule: {
                patientId: this.patientId,
                id: myMedicationScheduleId,
                classes: classes,
                dosages
              }
            },
        })
        .then(() => {
          this.initialSelection = this.selectedClasses;

          this.$emit('updatedClasses')
        })
        .catch(() => {
          this.selectedClasses = this.initialSelection;
          this.$toasted.show(
              "Cannot update medication classes. Try again later."
          );
        })
        .finally(() => {
          this.classesToSubmit = [];
          this.duplicatedClasses = [];
        })
    }, 500)
  },
};
</script>

<style lang="scss">
@import "../../../../scss/colors";

.deleted {
  text-decoration: line-through;
}

.c-medication-row {
  font-family: "Futura", serif;
}

.c-medication-row__medication {
  font-weight: 500;
  font-size: 1.2em;
  line-height: 0.1em;
}

.c-medication-row__medication-dose {
  color: map-get($coroColors, info-500);
  font-weight: 600;
  font-size: 1em;
  line-height: 0.1em;
}

.c-medication-row__medication-frequency {
  color: map-get($coroColors, primary-400);
  font-weight: 500;
  font-size: 1em;
  line-height: 0.8em;
}

.c-medication-row__medication-time {
  font-size: 0.9em;
  line-height: 0.9em;
  text-transform: uppercase;
  text-align: center;
  color: map-get($coroColors, grey);

  &.has_medication {
    color: #303030;
    font-weight: 600;
  }
}

.c-medication-row__medication-times {
  font-size: 0.9em;
  line-height: 0.01em;
  font-weight: 600;
  color: map-get($coroColors, primary-400);
  text-align: center;
}

.c-medication-row__medication-medication-type {
  color: map-get($coroColors, info-500);
  font-size: 1.2em;
}

.c-medication-row__medication-motivation-of-change {
  font-size: 1.1em;
  line-height: 0.9em;
  font-weight: 500;
}
</style>
